import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-161">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" style={{
        backgroundColor: 'rgba(44, 44, 44, 0.5)'
      }} onClick={onClose} data-id="element-162">
            {/* Modal */}
            <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" style={{
          backgroundColor: '#F9F5EF'
        }} onClick={e => e.stopPropagation()} data-id="element-163">
              {/* Header */}
              <div className="flex items-center justify-between px-8 py-6 border-b" style={{
            borderColor: 'rgba(196, 168, 130, 0.2)'
          }} data-id="element-164">
                <h2 className="text-2xl md:text-3xl font-light" style={{
              fontFamily: "'Cormorant Garamond', serif",
              color: '#2C2C2C'
            }} data-id="element-165">
                  {title}
                </h2>
                <button onClick={onClose} className="w-8 h-8 flex items-center justify-center transition-opacity duration-200 hover:opacity-60" style={{
              color: '#8FAF88'
            }} aria-label="Close" data-id="element-166">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-167">
                    <path d="M1 1L17 17M17 1L1 17" data-id="element-168" />
                  </svg>
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="overflow-y-auto px-8 py-8 flex-1" style={{
            fontFamily: "'Jost', sans-serif",
            color: '#2C2C2C',
            lineHeight: '1.8'
          }} data-id="element-169">
                {children}
              </div>

              {/* Footer */}
              <div className="px-8 py-5 border-t text-center" style={{
            borderColor: 'rgba(196, 168, 130, 0.2)'
          }} data-id="element-170">
                <button onClick={onClose} className="text-xs uppercase tracking-[0.2em] font-medium transition-colors duration-200" style={{
              color: '#8FAF88'
            }} data-id="element-171">
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}